/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'actions-toggle-microphone-off-filled': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" d="M14.375 10.625a4.375 4.375 0 01-7.331 3.213l.887-.882a3.125 3.125 0 005.194-2.331V7.763l5.625-5.625-.881-.888L1.25 17.869l.881.881 4.025-4.025a5.569 5.569 0 003.219 1.487V17.5h-2.5v1.25h6.25V17.5h-2.5v-1.288a5.625 5.625 0 005-5.587V8.75h-1.25v1.875zm-8.75.2V8.75h-1.25v1.875c0 .44.053.878.156 1.306l1.094-1.106zm7.35-7.337a3.125 3.125 0 00-6.1.887v5.213l6.1-6.1z"/>'
  }
})
